import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ContinueButton from "../../Registration/ContinueButton";
import { useSelector, useDispatch } from "react-redux";
import { submitEndorsement, setEndorstmentInfo } from "../../store/supplierFormDataSlice";

const TestimonialsReferencesForm = ({ onNext, onSkip }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const testimonialsAndReferences = useSelector(
    (state) => state.formData.testimonialsAndReferences
  );
  const userId = useSelector((state) => state.formData.supplierId);

  const [entries, setEntries] = useState([]);

  useEffect(() => {
    if (testimonialsAndReferences && testimonialsAndReferences.length > 0) {
      setEntries(
        testimonialsAndReferences.map((value) => ({
          type: value.reference ? "Professional References" : "Client",
          name: value.endorsementInfo?.name || "",
          feedback: value.endorsementInfo?.feedback || "",
          contact: value.endorsementInfo?.contact || "",
          file: value.file || null,
        }))
      );
    } else {
      setEntries([{ type: "Client", name: "", feedback: "", contact: "", file: null }]);
    }
  }, [testimonialsAndReferences]);

  const [showModal, setShowModal] = useState(false);
  const [entryToDelete, setEntryToDelete] = useState(null);

  const handleChange = (index, key, value) => {
    setEntries((prev) =>
      prev.map((entry, i) => (i === index ? { ...entry, [key]: value } : entry))
    );
  };

  const handleFileChange = (index, file) => {
    setEntries((prev) =>
      prev.map((entry, i) => (i === index ? { ...entry, file } : entry))
    );
  };

  const addEntry = () => {
    setEntries((prev) => [
      ...prev,
      { type: "Client", name: "", feedback: "", contact: "", file: null },
    ]);
  };

  const handleDeleteClick = (index) => {
    setEntryToDelete(index);
    setShowModal(true);
  };

  const confirmDelete = () => {
    setEntries((prev) => prev.filter((_, i) => i !== entryToDelete));
    setShowModal(false);
    setEntryToDelete(null);
  };

  const cancelDelete = () => {
    setShowModal(false);
    setEntryToDelete(null);
  };

const handleSubmit = (e) => {
  e.preventDefault();
  onNext();
  
  const endorsementData = entries.map((entry) => ({
    id: userId, 
    reference: entry.type === "Professional References", 
    endorsementInfo: {
      company: entry.company || "",  
      name: entry.name,
      feedback: entry.feedback,
      contact: entry.contact || "",  
    },
    file: entry.file, 
    originalName: entry.file ? entry.file.name : null, 
  }));


  dispatch(submitEndorsement(endorsementData)); 
  dispatch(setEndorstmentInfo(endorsementData))
};
  return (
    <section className="flex flex-col items-center min-h-screen justify-start bg-white py-10 px-6">
      <header className="text-center mb-14">
        <h1 className="text-2xl font-semibold text-[#1D2639]">
          Testimonials & References
        </h1>
        <p className="text-base font-medium text-[#7E7E7E] w-full sm:w-[572px] mt-2">
          Share testimonials from satisfied clients and references from past projects. Positive
          feedback serves as social proof of your reliability and quality, building trust with
          potential buyers and setting you apart from competitors.
        </p>
      </header>
      <form className="flex flex-col w-full sm:w-[572px]" onSubmit={handleSubmit}>
        {entries.map((entry, index) => (
          <fieldset key={index} className="mb-8">
            <div className="flex justify-between">
              <label className="block text-[#1D2639] text-[12px] text-start font-normal mb-2">
                Type
              </label>
              {entries.length > 1 && (
                <button
                  type="button"
                  className="text-red-500"
                  onClick={() => handleDeleteClick(index)}
                >
                  Remove
                </button>
              )}
            </div>
            <div className="flex">
              <label className="mr-4">
                <input
                  type="radio"
                  name={`type-${index}`}
                  className="mr-1"
                  value="Client"
                  checked={entry.type === "Client"}
                  onChange={(e) => handleChange(index, "type", e.target.value)}
                />
                Client
              </label>
              <label>
                <input
                  type="radio"
                  name={`type-${index}`}
                  className="mr-1"
                  value="Professional References"
                  checked={entry.type === "Professional References"}
                  onChange={(e) => handleChange(index, "type", e.target.value)}
                />
                Professional References
              </label>
            </div>

            <label className="block text-[#1D2639] text-[12px] text-start font-normal mt-4 mb-2">
              Name
            </label>
            <input
              type="text"
              placeholder="Enter Name"
              className="w-full h-12 p-3 bg-[#F9F9F9] rounded-lg"
              value={entry.name}
              onChange={(e) => handleChange(index, "name", e.target.value)}
            />

            {entry.type === "Client" ? (
              <>
                <label className="block text-[#1D2639] text-[12px] text-start font-normal mt-4 mb-2">
                  Feedback
                </label>
                <textarea
                  className="w-full h-24 p-3 bg-[#F9F9F9] rounded-lg"
                  value={entry.feedback}
                  onChange={(e) => handleChange(index, "feedback", e.target.value)}
                />
              </>
            ) : (
              <>
                <label className="block text-[#1D2639] text-[12px] text-start font-normal mt-4 mb-2">
                  Contact Info
                </label>
                <input
                  type="text"
                  placeholder="Enter Contact Info"
                  className="w-full h-12 p-3 bg-[#F9F9F9] rounded-lg"
                  value={entry.contact}
                  onChange={(e) => handleChange(index, "contact", e.target.value)}
                />
              </>
            )}

            <label className="block text-[#1D2639] text-[12px] text-start font-normal mt-4 mb-2">
              Upload Supporting Documents
            </label>
            <input
              type="file"
              className="w-full h-12 p-3 bg-[#F9F9F9] rounded-lg"
              onChange={(e) => handleFileChange(index, e.target.files[0])}
            />
          </fieldset>
        ))}

        <button type="button" onClick={addEntry} className="text-blue-500 flex flex-row mb-4">
          + Add
        </button>

        <ContinueButton onClick={handleSubmit} label="Save and Continue" />
        <button
          type="button"
          className={`flex justify-center cursor-pointer items-center self-center w-full sm:w-[432px] h-14 p-5 mt-4
    rounded-[13px] text-center text-base font-medium border border-gray-300`}
          aria-label="Skip"
          onClick={onSkip}
        >
          Skip
        </button>
      </form>

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg text-[#1D2639]">Are you sure you want to delete this entry?</p>
            <div className="flex justify-end mt-4">
              <button onClick={cancelDelete} className="text-gray-500 mr-4">
                Cancel
              </button>
              <button onClick={confirmDelete} className="text-red-500">
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TestimonialsReferencesForm;